import React, { useContext } from "react";
import { Box, ListItem, ListItemText } from "@mui/material";
import { getColors } from "../../themes/theme";
import { ThemeContext } from "../../context/ThemeContext";

export const SubList = ({ subItems, selectedSubId, onSubSelect }) => {
  const { darkMode } = useContext(ThemeContext);

  return (
    <Box
      sx={{
        width: "260px",
        px: "20px",
        borderRight: `1px solid ${
          darkMode ? getColors.appBarBorderDark : getColors.appBarBorderLight
        }`,
      }}
    >
      {subItems?.map((subItem) => (
        <ListItem
          key={subItem.id}
          button
          onClick={() => onSubSelect(subItem.id)}
          sx={{
            fontSize: "22px",
            px: "28px",
            py: "14px",
            mb: 1,
            background:
              selectedSubId === subItem.id
                ? getColors.listItemHoverBg
                : "transparent",
            "&:hover": {
              background: getColors.listItemHoverBg,
            },
          }}
        >
          <ListItemText
            primary={subItem.name}
            sx={{
              "& .MuiListItemText-primary": {
                color:
                  selectedSubId === subItem.id
                    ? getColors.primaryTextDark
                    : darkMode
                    ? getColors.drawerTextDark
                    : getColors.thumbnailTextLight,
              },
            }}
          />
        </ListItem>
      ))}
    </Box>
  );
};
